import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { useSettings } from 'app/main/components';
import ViewList, { type ViewListProps } from 'app/main/components/page-layouts/view/list/ViewList';
import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';

interface AddRowsResultDialogProps {
	title: string;
	module: string;
	itemLayout: ViewListProps['itemLayout'];
	defaultFilters?: MiddlewhereFilter[];
	defaultQuery?: any;
	addRows: () => void;
	goBack: () => void;
}

export default function AddRowsResultDialog(props: AddRowsResultDialogProps) {
	const { t } = useSettings();

	return (
		<>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent className="p-0">
				<ViewList
					module={props.module}
					itemLayout={props.itemLayout}
					defaultFilters={props.defaultFilters}
					defaultQuery={props.defaultQuery}
					showBottomPagination={false}
					showFilters={false}
					showExportButton={false}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.goBack}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={props.addRows}>
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
